<div class="e-process-page">
    <div class="page-wrap">
        <div class="main-content">
            <h1>Getting Started</h1>
            <p>Just a few quick steps to complete your account set up. Click continue to get started.</p>

            <div class="btn-width">
                <button (click)="continue()" style="width: 100%" class="mt-2 auth-form-submit" mat-flat-button type="submit" color="primary">Continue</button>
            </div>
        </div>
    </div>
</div>
